<script lang="ts">
</script>

<style lang="postcss">
  .draftBadge {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: var(--ubilabs-border-radius-medium);
    background-color: var(--ubilabs-gray-dark-2);
    color: var(--ubilabs-white);
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 1px;
    white-space: nowrap;
    pointer-events: none;
  }
</style>

<div class="draftBadge {$$props.class}">Draft</div>
